/**
 * Session-API add-result / void success — sync settle or RabbitMQ queued.
 */
export function isFancyResultQueued(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false
  const o = data as Record<string, unknown>
  if (o.queued === true) return true
  const nested = o.data
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return (nested as Record<string, unknown>).queued === true
  }
  return false
}

export function fancyResultSuccessMessage(data: unknown): string {
  if (data && typeof data === 'object') {
    const msg = (data as Record<string, unknown>).msg
    if (typeof msg === 'string' && msg.trim()) return msg.trim()
  }
  if (isFancyResultQueued(data)) return 'Result queued for settlement'
  return 'Result Declared Succesfully'
}
